// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__i3gFh","comment":"styles_comment__3xyph"};